module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-12-e3b346fc5c561e1b10a2d55f52069873.jpg";